var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 190 166",
    id: "excel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 142,
    height: 166,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 71,
    height: 42,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "h",
    width: 71,
    height: 42,
    x: 71,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "l",
    width: 71,
    height: 42,
    y: -1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "p",
    width: 71,
    height: 42,
    x: 71,
    y: -1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "t",
    width: 71,
    height: 42,
    y: 83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "x",
    width: 71,
    height: 42,
    x: 71,
    y: 83
  }), /*#__PURE__*/React.createElement("rect", {
    id: "B",
    width: 71,
    height: 42,
    y: 125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "F",
    width: 71,
    height: 42,
    x: 71,
    y: 125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "I",
    width: 142,
    height: 166,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "L",
    width: 96,
    height: 96,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "R",
    width: 96,
    height: 98,
    y: -1,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: "143.7%",
    height: "173.8%",
    x: "-21.8%",
    y: "-36.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner3",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner3",
    result: "shadowMatrixInner3",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner3"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    width: "101.4%",
    height: "102.4%",
    x: "-.7%",
    y: "-1.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0.709803922   0 0 0 0 0.37254902  0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "v",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "z",
    width: "101.4%",
    height: "102.4%",
    x: "-.7%",
    y: "-1.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "D",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner3",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner3",
    result: "shadowMatrixInner3",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner3"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "H",
    width: "102.8%",
    height: "104.8%",
    x: "-1.4%",
    y: "-2.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "J",
    width: "117%",
    height: "117%",
    x: "-8.5%",
    y: "-8.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Q",
    width: "103.1%",
    height: "103.1%",
    x: "-1.6%",
    y: "-1.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 0.0199267733   0 0 0 0 0.65973108   0 0 0 0 0.312408742  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0   0 0 0 0 0.466666667   0 0 0 0 0.250980392  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "S",
    width: "141.7%",
    height: "137.9%",
    x: "-20.8%",
    y: "-17%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "6.294%",
    x2: "103.402%",
    y1: "0%",
    y2: "103.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#007438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.34%",
    stopColor: "#008B44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "107.466%",
    x2: "6.294%",
    y1: "107.831%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00D576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.026%",
    stopColor: "#00A054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "6.294%",
    x2: "107.466%",
    y1: "0%",
    y2: "107.831%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#007E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95.983%",
    stopColor: "#009A50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "6.294%",
    x2: "107.466%",
    y1: "0%",
    y2: "107.831%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00AD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E18C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: "107.466%",
    x2: "9.303%",
    y1: "107.831%",
    y2: "3.207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#003D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004F2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: "107.466%",
    x2: "9.303%",
    y1: "107.831%",
    y2: "3.207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#008D46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "107.466%",
    x2: "9.303%",
    y1: "107.831%",
    y2: "3.207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00522E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#003B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: "107.466%",
    x2: "9.303%",
    y1: "107.831%",
    y2: "3.207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#006D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: "113.177%",
    x2: "2.151%",
    y1: "104.673%",
    y2: "9.713%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: "29.468%",
    x2: "97.963%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "e",
    width: 512,
    height: 512,
    x: -512,
    y: -471,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "i",
    width: 512,
    height: 512,
    x: -441,
    y: -471,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "m",
    width: 512,
    height: 512,
    x: -512,
    y: -513,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "q",
    width: 512,
    height: 512,
    x: -441,
    y: -513,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "u",
    width: 512,
    height: 512,
    x: -512,
    y: -429,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "y",
    width: 512,
    height: 512,
    x: -441,
    y: -429,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "C",
    width: 512,
    height: 512,
    x: -512,
    y: -387,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "G",
    width: 512,
    height: 512,
    x: -441,
    y: -387,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "O",
    width: 512,
    height: 512,
    x: -512,
    y: -512,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "N",
    cx: "86.601%",
    cy: "84.21%",
    r: "62.398%",
    fx: "86.601%",
    fy: "84.21%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#018137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007E35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "T",
    points: "25 73.107 41.756 46.96 26.572 23 38.144 23 47.977 41.099 57.61 23 69.082 23 53.83 47.336 70.587 73.107 58.647 73.107 47.777 53.778 36.873 73.107"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#e)",
    fillOpacity: 0.012,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#g)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#i)",
    fillOpacity: 0.012,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#j)",
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#k)",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#m)",
    fillOpacity: 0.012,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#n)",
    xlinkHref: "#l"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#o)",
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#q)",
    fillOpacity: 0.012,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#r)",
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#s)",
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#u)",
    fillOpacity: 0.012,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#v)",
    xlinkHref: "#t"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#w)",
    xlinkHref: "#x"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#y)",
    fillOpacity: 0.012,
    xlinkHref: "#x"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#z)",
    xlinkHref: "#x"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#A)",
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#C)",
    fillOpacity: 0.012,
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#D)",
    xlinkHref: "#B"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#E)",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#G)",
    fillOpacity: 0.012,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#H)",
    xlinkHref: "#F"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "K",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M-40,37 L40,37 C44.418278,37 48,40.581722 48,45 L48,125 C48,129.418278 34.418278,143 30,143 L-50,143 C-54.418278,143 -58,139.418278 -58,135 L-58,55 C-58,50.581722 -44.418278,37 -40,37 Z",
    filter: "url(#J)",
    mask: "url(#K)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#M)",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#N)",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#O)",
    fillOpacity: 0.013,
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#P)"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#Q)",
    xlinkHref: "#R"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#P)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#S)",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#U)",
    xlinkHref: "#T"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.d6ff63d3.svg";
export { ForwardRef as ReactComponent };